import dynamic from "next/dynamic";

export const ServicesExpandable = dynamic(() => import("./component"));
